<template>
  <div style="text-align: left">  
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
     <el-table-column
        width="80"
        prop="id"
        label="序号"       
        align="center"
      >
    <template slot-scope="scope">
      {{ (searchForm.page - 1) * searchForm.pageSize + scope.$index + 1 }}
    </template>
    </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="主办方名称"
      ></el-table-column>
      <el-table-column
        prop="businessOwner"
        align="center"
        label="负责人"
      ></el-table-column>
      <el-table-column
        prop="contact"
        align="center"
        label="联系方式"
      ></el-table-column>
      <el-table-column prop="qQ" align="center" label="QQ"></el-table-column>
      <el-table-column
        prop="email"
        align="center"
        label="邮箱"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">        
          <el-button
            type="text"
            size="small"
            @click="editHost(scope.row)"
            class="btn"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[1, 5, 15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'编辑主办方'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="单位名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="businessOwner">
          <el-input v-model="form.businessOwner" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="form.contact" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="QQ" prop="qQ">
          <el-input v-model="form.qQ" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="创建代表队" v-if="form.id > 0" prop="qQ">
          <el-switch
            v-model="form.isAllowRegister"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="说明" prop="description">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入竞赛规程"
            v-model="form.description"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/host'
export default {
    props: ['matchId'],
  data () {
    var validateMobile = (rule, value, callback) => {
      const reg = /^[0-9]{11}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    return {
      isLoading: false,
      dialogFormVisible: false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      searchForm: {
        name: null,
       matchId: this.matchId,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        name: '',
        businessOwner: '',
        contact: '',
        qQ: '',
        email: '',
        description: '',
        isAllowRegister: false
      },
      formRules: {
        name: [{ required: true, message: '请输入主办方名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系方式', trigger: 'blur' },
         { validator: validateMobile, trigger: "blur" }],
      }
    }
  },
  methods: {
    editHost (row) {
      this.formTitle = "编辑";
      API.get({ id: row.id }).then(result => {
        this.dialogFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },   
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    search: function () {
      API.matchList({matchId:this.matchId}).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    doSearch () {
      this.search.page = 1
      this.search()
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.add(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['form'].resetFields();
                this.dialogFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: '新增失败', duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    }   
  },
  computed: {
  },
  mounted () {
    this.search()
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Host.vue